export const ABORT_ERROR_NAME = "AbortError";

export class AbortError extends Error {
  name = ABORT_ERROR_NAME;
}

export const isAbortError = (error: unknown): error is AbortError =>
  error instanceof AbortError;
